<template>
  <div class="ms-access-page container py-4">
    <!-- Page Heading -->
    <h2 class="mb-4">MS Access</h2>

    <!-- Description / Introduction -->
    <p>
      MS Access is a database management system that allows you to create, manage, and query databases.
      It is useful for storing large amounts of data, building forms, and generating reports efficiently.
    </p>

    <!-- Example Features List -->
    <h5 class="mt-4">Key Features of MS Access:</h5>
    <ul>
      <li>Creating and managing relational databases</li>
      <li>Designing tables, queries, forms, and reports</li>
      <li>Using macros and automation for tasks</li>
      <li>Importing and exporting data from other sources</li>
      <li>Building user-friendly forms for data entry</li>
    </ul>

    <!-- Example Image / Screenshot -->
    <div class="mt-4 text-center">
      <img
        src="@/assets/Tutorials/MSOffice/ms-access.png"
        alt="MS Access Example"
        class="img-fluid rounded shadow-sm"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "MsAccess",
};
</script>

<style scoped>
h2 {
  color: #9333ea; /* Purple heading for Access */
  font-weight: 700;
}

ul {
  list-style-type: disc;
  margin-left: 20px;
}

p {
  font-size: 1rem;
  line-height: 1.6;
  color: #374151;
}

img {
  max-width: 100%;
  height: auto;
}
</style>
